
(function($) {	
$(document).ready(function(){   
  setTimeout(function(){
	$('.releted-slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		nav:true,
		pagination:false,  dots: false,
		navText: ["<img src='https://cdn.shopify.com/s/files/1/0771/6900/0733/files/Vector_175.png?v=1689759497'>","<img src='https://cdn.shopify.com/s/files/1/0771/6900/0733/files/Vector_176.png?v=1689759498'>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        768:{
	            items:2
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:3
	        }
	    }
	});	
    },4500);
});

}) (jQuery);


$(document).ready(function(){    
  
	$('.feature-slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
      center:true,
		pagination:false,  dots: false,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        768:{
	            items:2
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 


	$('.logo-slider-top').slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 4000,
  pauseOnHover: false, variableWidth: true,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});

$('.logo-slider-bottom').slick({
  dots: false,
  infinite: true,
  autoplay: true, variableWidth: true,
  rtl:true,
  autoplaySpeed: 0,
  speed: 4000,
  pauseOnHover: false,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});
	 
});


var counted = 0;
$(window).scroll(function() {

  var oTop = $('.counter_section').offset().top - window.innerHeight;
  if (counted == 0 && $(window).scrollTop() > oTop) {

    $('.count').each(function () {
    $(this).prop('Counter',0).animate({
        Counter: $(this).text()
    }, {
        duration: 4000,
        easing: 'swing',
        step: function (now) {
            // $(this).text(Math.ceil(now));
           $(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
        }
    });
});
     counted = 1;
  }

});
function getId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11)
      ? match[2]
      : null;
}
jQuery(document).on("click",".member_box",function(){
  var vid_url=$(this).attr("data_video");
  var videoId = getId(vid_url);
  $(".modal_video").attr("src","https://www.youtube.com/embed/"+videoId);
});
jQuery(document).on("click",".prev_trigger_btn",function(){
  jQuery(".slider_in_featured .owl-nav .owl-prev").trigger("click");
});
jQuery(document).on("click",".next_trigger_btn",function(){
   jQuery(".slider_in_featured .owl-nav .owl-next").trigger("click");
});

$(".modal").on("hidden.bs.modal", function () {
     $(this).find('iframe').attr('src', $(this).find('iframe').attr('src'));
   $("video").get(0).pause();
});